import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { getPointsRule, postPointsRule } from '../../../api/points';
import NEditor from '@/component/NForm/NEditor/NEditor.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'rule',
  setup(__props) {

const editorData = ref<any>();
const editStatus = ref<boolean>(true);
const initValue = ref<string>('');

function onEdit() {
  editStatus.value = false;
}
async function onSave() {
  if (editorData.value == initValue.value) {
    //判断当次保存是否需要更新
    editStatus.value = true;
    return;
  }

  if (await postPointsRule(editorData.value)) {
    //保存默认数据，用于下次保存时判断是否需要更新
    // eslint-disable-next-line require-atomic-updates
    initValue.value = editorData.value || '';
    editStatus.value = true;
  }
}

async function query() {
  const res = await getPointsRule();
  if (res) {
    initValue.value = res?.rule || '';
    editorData.value = res?.rule || '';
  }
}
query();

return { __sfc: true,editorData, editStatus, initValue, onEdit, onSave, query, NEditor }
}

})